<style scoped>
	#app {
		padding: 10px 20px 20px 20px;
	}
	.header {
		line-height: 60px;
		font-size: 16px;
		font-weight: bold;
		
	}
	.line {
		display: flex; flex-direction: row; justify-content: center;
		margin-bottom: 20px; align-items: flex-start;
	}
	.box1 {
		margin-right: 20px;
		margin-bottom: 20px;
		width: 259px; height: 240px; background-color: white;
		box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
		border-radius: 5px;
		display: flex;
		flex-direction: column;
	}
	.box4 {
		width: 360px; height: 290px; background-color: white;
		box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
		border-radius: 5px;
		display: flex;
		flex-direction: column;
	}
	.box3 {
		width: calc(100% - 380px); background-color: white;
		box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
		border-radius: 5px;
		display: flex;
		flex-direction: column;
	}
	.box2 {
		min-width: 400px;
		width: 49%; height: 280px; background-color: white;
		box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
		border-radius: 5px;
		margin-left: 10px;
		margin-right: 10px;
	}
	.box-header {
		border-bottom: solid 1px #F6F6F6;
		height: 60px;
		line-height: 60px;
		font-size: 16px;
		font-weight: bold;
		text-indent: 20px;
	}
	.box-p {
		height: 280px; width: calc(100% - 370px); display: flex; flex-direction: row; justify-content: space-between;
	}
	.user-box {
		width: 100%;
		text-align: center;
		height: 100px;
		line-height: 100px;
		font-size: 28px;
		color: #1677FF;
		font-weight: bold;
	}
	.user-line {
		display: flex;
		flex-direction: row;
	}
	.user-col {
		width: 50%;
	}
	.user-item {
		text-align: center;
		line-height: 30px;
		font-size: 14px;
	}
	
	.tr {
		display: flex;
		flex-direction: row;
		border-bottom: solid 1px #F6F6F6;
	}
	.th {
		background-color: #FbFbFb;
		width: 25%;
		height: 50px;
		line-height: 50px;
		text-indent: 20px;
		font-weight: bold;
		font-size: 15px;
	}
	.td {
		width: 25%;
		height: 50px;
		line-height: 50px;
		text-indent: 20px;
		font-size: 14px;
	}
	.b {
		font-weight: bold;
	}
</style>
<template>
	<div id="app">
		<div class="line">
			<div style="display: flex; flex-direction: row; width: 52%; flex-wrap: wrap;">
				<div class="box1">
					<div class="box-header">昨日出票</div>
					<div class="user-box">{{static.ticket.day2}}</div>
					<div class="user-line">
						<div class="user-col">
							<div class="user-item">{{static.ticket.day1}}</div>
							<div class="user-item">今日出票</div>
						</div>
						<div class="user-col">
							<div class="user-item">{{static.ticket.dayt}}</div>
							<div class="user-item">总出票金额</div>
						</div>
					</div>
				</div>
				
			
				<div class="box1">
					<div class="box-header">昨日派奖</div>
					<div class="user-box">{{static.award.day2}}</div>
					<div class="user-line">
						<div class="user-col">
							<div class="user-item">{{static.award.day1}}</div>
							<div class="user-item">今日派奖</div>
						</div>
						<div class="user-col">
							<div class="user-item">{{static.award.dayt}}</div>
							<div class="user-item">总派奖金额</div>
						</div>
					</div>
				</div>
				
				<div class="box1">
					<div class="box-header">昨日服务费消耗</div>
					<div class="user-box">{{static.fee.day2}}</div>
					<div class="user-line">
						<div class="user-col">
							<div class="user-item">{{static.fee.day1}}</div>
							<div class="user-item">今日消耗</div>
						</div>
						<div class="user-col">
							<div class="user-item">{{static.fee.dayt}}</div>
							<div class="user-item">总消耗</div>
						</div>
					</div>
				</div>
				
				<div class="box1">
					<div class="box-header">昨日店主注册</div>
					<div class="user-box">{{static.shop.day2}}</div>
					<div class="user-line">
						<div class="user-col">
							<div class="user-item">{{static.shop.day1}}</div>
							<div class="user-item">今日注册</div>
						</div>
						<div class="user-col">
							<div class="user-item">{{static.shop.dayt}}</div>
							<div class="user-item">总注册</div>
						</div>
					</div>
				</div>
				<div class="box1">
					<div class="box-header">昨日注册用户</div>
					<div class="user-box">{{static.user.day2}}</div>
					<div class="user-line">
						<div class="user-col">
							<div class="user-item">{{static.user.day1}}</div>
							<div class="user-item">今日注册</div>
						</div>
						<div class="user-col">
							<div class="user-item">{{static.user.dayt}}</div>
							<div class="user-item">总注册</div>
						</div>
					</div>
				</div>
				<div class="box1">
					<div class="box-header">三方充值</div>
					<div class="user-box">{{static.three.dayt}}</div>
					<div class="user-line">
						<div class="user-col">
							<div class="user-item">{{static.three.day1}}</div>
							<div class="user-item">今日充值</div>
						</div>
						<div class="user-col">
							<div class="user-item">{{static.three.day2}}</div>
							<div class="user-item">昨日充值</div>
						</div>
					</div>
				</div>
			</div>
			
			<div style="width: 48%; display: flex; flex-direction: row;">
				<div style="width: 50%; margin-right: 10px;">
					<div style="width: 100%; height: 40px; background-color: white; text-align: center; line-height: 40px;">昨日出票排行</div>
					<el-table :data="yTicket" border style="width: 100%;">
						<el-table-column prop="shop_name" label="店铺"  align="center"></el-table-column>
						<el-table-column prop="totalAmount" label="出票金额" align="center"></el-table-column>
						<el-table-column prop="totalAward" label="派奖金额" align="center"> </el-table-column>
					</el-table>
				</div>
				<div style="width: 50%;">
					<div style="width: 100%; height: 40px; background-color: white; text-align: center; line-height: 40px;">今日出票排行</div>
					<el-table :data="tTicket" border style="width: 100%;">
						<el-table-column prop="shop_name" label="店铺"  align="center"></el-table-column>
						<el-table-column prop="totalAmount" label="出票金额" align="center"></el-table-column>
						<el-table-column prop="totalAward" label="派奖金额" align="center"> </el-table-column>
					</el-table>
				</div>
			</div>
		</div>
		
		
	</div>
</template>

<script>
	
	
	
	export default {
		name:'Dashboard',
		data(){
			return {
				yTicket:[],
				tTicket:[],
				static:{
					ticket:{
						day1:'-',
						day2:'-',
						dayt:'-',
					},
					award:{
						day1:'-',
						day2:'-',
						dayt:'-',
					},
					fee:{
						day1:'-',
						day2:'-',
						dayt:'-',
					},
					shop:{
						day1:'-',
						day2:'-',
						dayt:'-',
					},
					user:{
						day1:'-',
						day2:'-',
						dayt:'-',
					},
					three:{
						day1:'-',
						day2:'-',
						dayt:'-',
					}
				}
			}
		},
		mounted() {
		},
		created() {
			this.getData()
		},
		methods:{
			getData(){
				let _this = this;
				const loading = this.$loading({
						lock: true,
						text: '加载中',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
				_this.$api.get("/Dashboard/getStatic", {}).then(res=>{
					loading.close();
					if(res.code == 200)
					{
						_this.static = res.data.statics;
						_this.yTicket = res.data.yTicket;
						_this.tTicket = res.data.tTicket;
					}else{
						return _this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
				}).catch(err=>{
					loading.close();
				});
			}
		}
	}
</script>

